import styled from 'styled-components';
import MarketoForm from '../MarketoForm';

const Container = styled.div`
  display: none;

  @media (max-width: 680px) {
    background: white;
    display: ${({ showForm }) => (showForm ? 'block' : 'none')};
    position: fixed;
    width: 100%;
    bottom: 0px;
    left: 0px;
    z-index: 9;
  }
`;

const StyledForm = styled(MarketoForm)`
  padding: 10px 24px;

  .data-layer-form {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;

    .ant-form-item:nth-child(1) {
      width: calc(70% - 10px);
    }
    .ant-form-item:nth-child(2) {
      width: calc(30% - 10px);
    }

    button {
      padding: 8px !important;
    }
  }
`;

export { Container, StyledForm };
